import Group from "../../groups/Group";
import Term from "../Term";

export function extractGroupsFromTerms(terms: Term[]): Group[] {
  const seen = new Set<string>();
  const groupNames: string[] = [];
  const result: Group[] = [];

  for (const term of terms) {
    const groupName = term.group;
    if (!seen.has(groupName)) {
      seen.add(groupName);
      groupNames.push(groupName);
    }
  }

  for (const name of groupNames) {
    const group = new Group(0, 0, name, 0, "", 0);
    result.push(group);
  }

  return result;
}

export function extractCorrectAnswers(terms: Term[]): Term[] {
  return terms.filter((t) => t.isCorrectAnswer);
}

export function extractIncorrectAnswers(terms: Term[]): Term[] {
  return terms.filter((t) => !t.isCorrectAnswer);
}

export function extractCorrectAnswersWithGroup(
  terms: Term[],
  groupName: string
): Term[] {
  return terms.filter((t) => t.isCorrectAnswer && t.group === groupName);
}

export function extractIncorrectAnswersWithGroup(
  terms: Term[],
  groupName: string
): Term[] {
  return terms.filter((t) => !t.isCorrectAnswer && t.group === groupName);
}
